import type { ChangeEventHandler, ComponentProps } from 'react'

import { Toggle } from '@/components/ui/Toggle.tsx'
import { TextField } from '@/components/ui/text-field.tsx'
import { SettingsOption } from '@/modules/creator-settings/ui/SettingsOption'
import { classNames } from '@/utils/helpers.ts'

export type SpendLimitationProps = ComponentProps<'div'> & {
  value: number | null
  onValueChange?: ChangeEventHandler<HTMLInputElement>
  enabled: boolean
  onToggle: () => void
  textFieldClassName?: string
  disabled?: boolean
}

export const SpendLimitation = ({
  value,
  onValueChange,
  className,
  enabled,
  onToggle,
  textFieldClassName,
  disabled,
  ...props
}: SpendLimitationProps) => {
  return (
    <SettingsOption
      title="Spending Limitation"
      description="Only send messages to fans who spent less than the specified amount"
      mobileVertical
      biggerTitle
    >
      <div className="flex flex-col items-start gap-2 md:items-end">
        <div className="flex items-center gap-4">
          <span className="text-text-default text-sm">Activate</span>
          <Toggle
            name="spendLimitation"
            onChange={onToggle}
            checked={enabled}
            disabled={disabled}
          />
        </div>
        {enabled && (
          <TextField
            type="number"
            step="1"
            className={classNames('max-w-[110px]', textFieldClassName)}
            onChange={onValueChange}
            value={value ?? undefined}
            disabled={disabled}
            prefix={<span className="text-text-sub flex items-center">$</span>}
          />
        )}
      </div>
    </SettingsOption>
  )
}
